import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import PropertyListing from './pages/PropertyListing';
import PropertyDetail from './pages/PropertyDetail';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import AdminDashboard from './admin/AdminDashboard';
import PrivateRoute from './auth/PrivateRoute';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="app">
          <div className="cyber-grid"></div>
          <div className="particles">
            {[...Array(20)].map((_, i) => (
              <div key={i} className="particle" style={{
                '--size': `${Math.random() * 6 + 2}px`,
                '--x': `${Math.random() * 100}vw`,
                '--y': `${Math.random() * 100}vh`,
                '--delay': `${Math.random() * 5}s`,
                '--duration': `${Math.random() * 10 + 10}s`
              }}></div>
            ))}
          </div>
          <Header />
          <main className="container">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/nekretnine" element={<PropertyListing />} />
              <Route path="/nekretnina/:id" element={<PropertyDetail />} />
              <Route path="/prijava" element={<LoginPage />} />
              <Route path="/registracija" element={<RegisterPage />} />
              
              <Route element={<PrivateRoute roles={['admin']} />}>
                <Route path="/admin" element={<AdminDashboard />} />
              </Route>
              
              <Route path="*" element={
                <div className="not-found">
                  <h2>Stranica nije pronađena</h2>
                  <p>Tražena stranica ne postoji u našem sustavu.</p>
                  <Link to="/" className="home-link">Vratite se na početnu</Link>
                </div>
              } />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;